import {load} from '@shopify/theme-sections';

import '../sections/featured-collection-slider';

document.addEventListener('DOMContentLoaded', () => {
  load('*');
});
